<div *ngIf="this.clientEntity !== null">
    <p>
        Bij de klantinstellingen van {{ this.clientEntity.achternaam }} maak je een koppeling met een Snelstart
        administratie.<br/>
        Hieronder kun je er voor kiezen de gegevens uit de administratie te gebruiken bij de belastingaangifte.<br/>
        Maak je na het inlezen wijzigingen in de administratie, dan worden deze NIET automatisch opnieuw ingelezen in de
        aangifte. <br/>Je kunt er wel alsnog zelf voor kiezen de nieuwe gegevens in te lezen. Zie 'Toelichting'.<br/>
    </p>
  <div *ngIf="loginStatus && hasExternalProvider">
    <snelstart-ui-alert>
      Je bent uitgelogd bij {{this.externalProviderId}}
      <button (click)="goToExternalProvider()">Login bij {{this.externalProviderId}}</button>
    </snelstart-ui-alert>
  </div>

    <form [formGroup]="sstAdminIdFg">

            <snelstart-ui-select-form-control formControlName="inlezen"
                                              id="inlezenAdmin"
                                              label="SnelStart administratie inlezen"
                                              [options]="optionsJaNee"
                                              class="custom-input-250"
                                              (change)="checkData()"
            >
            </snelstart-ui-select-form-control>

        <div
                *ngIf="sstAdminIdFg.get('inlezen')?.value === true">

                <snelstart-ui-select-form-control formControlName="administrationId"
                                                  label="SnelStart administratie"
                                                  [options]="administrationList"
                                                  class="custom-input-250"
                                                  (change)="onSelect(sstAdminIdFg.get('administrationId')?.value)">
                </snelstart-ui-select-form-control>



                <snelstart-ui-button type="primary"
                                     class="me-1 pt-1 custom-input-250"
                                     (click)="this.getImportAdmin()">
                    Administratie inlezen
                </snelstart-ui-button>


            <div class="space40"></div>

            <div *ngIf="this.vpbBerekening.jaarstukken && this.vpbBerekening.jaarstukken.resultaat &&
                    this.vpbBerekening.jaarstukken.resultaat.totaalBedrijfsopbrengsten !== 0 &&
                    this.vpbBerekening.jaarstukken.resultaat.totaalBedrijfslasten !== 0">
                    <snelstart-ui-alert type="warning">
                        Let op! De aangifte is al ingevuld. Bij het (opnieuw) inlezen van de administratie worden de
                        gegevens van de balans en/of resultatenrekening overschreven.
                    </snelstart-ui-alert>
            </div>

            <div *ngIf="showSpinner" class="d-flex">
                <div class="space20"></div>
                <snelstart-ui-spinner [extraLarge]="true"></snelstart-ui-spinner>
            </div>

        </div>
    </form>
</div>
